import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MapPin, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { UbicacionGuardada } from "@/components/common/UbicacionGuardada";
import { api } from "@/lib/api";

const CONFIRMA_TEXT =
  "Confirmo que realizo la visita en el domicilio del prospecto. Se capturará un único punto de " +
  "ubicación como evidencia del cotejo presencial (no es rastreo de jornada).";

// Confirmación OPCIONAL y PUNTUAL de visita presencial (un solo punto, sin rastreo continuo).
export function GeoVisitaProspecto({ recordId }) {
  const [geo, setGeo] = useState(null);
  const [activar, setActivar] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!recordId) return;
    api.get(`/prospectos/${recordId}`).then((r) => setGeo(r.data?.geo_visita || null)).catch(() => {});
  }, [recordId]);

  const confirmar = async () => {
    if (!("geolocation" in navigator)) { toast.error("Tu dispositivo no permite geolocalización."); return; }
    setBusy(true);
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        try {
          const { data } = await api.post(`/prospectos/${recordId}/geo-visita`, {
            lat: pos.coords.latitude, lng: pos.coords.longitude, exactitud: pos.coords.accuracy,
          });
          setGeo(data.geo_visita);
          toast.success("Visita presencial confirmada con geolocalización.");
        } catch (e) {
          toast.error(e?.response?.data?.detail || "No se pudo guardar la ubicación");
        } finally { setBusy(false); }
      },
      () => { toast.error("No se pudo obtener tu ubicación. Activa el permiso de GPS."); setBusy(false); },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 },
    );
  };

  if (geo) {
    return <UbicacionGuardada geo={geo} label="Visita presencial confirmada (geolocalización)" testid="geo-visita-confirmada" />;
  }

  return (
    <div data-testid="geo-visita-control" className="rounded-md border border-slate-200 p-3">
      <label className="flex items-start gap-2 text-xs font-medium text-slate-700">
        <Checkbox data-testid="geo-visita-toggle" checked={activar} onCheckedChange={setActivar} />
        <span className="flex items-center gap-1"><MapPin className="h-3.5 w-3.5 text-primary" /> Confirmar ubicación de la visita <span className="text-slate-400">(opcional)</span></span>
      </label>
      {activar && (
        <div className="mt-2 space-y-2">
          <p className="rounded bg-slate-50 p-2 text-[11px] text-slate-600">{CONFIRMA_TEXT}</p>
          <Button data-testid="geo-visita-confirmar" size="sm" onClick={confirmar} disabled={busy} className="gap-1.5 bg-primary hover:bg-sidebar-hover">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <MapPin className="h-4 w-4" />} Confirmar ubicación
          </Button>
        </div>
      )}
    </div>
  );
}
